import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'tun-location-icon',
    templateUrl: './location-icon.component.html',
    styleUrls: ['./location-icon.component.scss'],
    standalone: false
})
export class LocationIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
